module.exports = __webpack_public_path__ + "static/media/transit_cluster.52a1a9ca.svg";